import React from 'react';

import { Button } from '@mui/material';

import { CANCEL, CONFIRM } from '../../constants/Dashboard';

import './ModalButtonRow.css';

export const ModalButtonRow = ({ onCancel, onConfirm, valid = true }) => {
  return (
    <div className="modal-button-row-wrapper">
      <Button
        sx={{
          '&:hover': { backgroundColor: 'rgb(240, 240, 240);', color: 'black' },
          m: 0,
          color: 'black',
          textTransform: 'initial',
          backgroundColor: 'rgb(240, 240, 240)',
          width: '50%',
          borderRadius: 2,
          height: '48px',
          mr: '3px',
          marginBottom: 2,
        }}
        onClick={onCancel}
      >
        {CANCEL}
      </Button>
      <Button
        sx={{
          '&:hover': { backgroundColor: 'black', color: 'white' },
          '&:disabled': { color: 'white', opacity: 0.5 },
          m: 0,
          color: 'white',
          textTransform: 'initial',
          backgroundColor: 'black',
          width: '50%',
          borderRadius: 2,
          ml: '3px',
          height: '48px',
          marginBottom: '20px',
        }}
        disabled={!valid}
        onClick={onConfirm}
      >
        {CONFIRM}
      </Button>
    </div>
  );
};
